// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609141404/js/" + chunkId + "." + {"44":"494d379f","225":"6d198f7a","481":"d4c93b49","486":"f97921dc","770":"097af990"}[chunkId] + ".0.6663561549266673.chunk.js";
};